import { useState, useRef } from 'react';
import { Button } from './ui/button';
import { Play, Pause, Mic } from 'lucide-react';

export default function VoicePlayer({ url }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [playbackTime, setPlaybackTime] = useState(0);
  const [audioDuration, setAudioDuration] = useState(0);
  const audioRef = useRef(null);

  const formatTime = (sec) => {
    if (!sec || isNaN(sec)) return '0:00';
    const m = Math.floor(sec / 60);
    const s = Math.floor(sec % 60);
    return `${m}:${s.toString().padStart(2, '0')}`;
  };

  const togglePlayback = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  const progress = audioDuration > 0 ? (playbackTime / audioDuration) * 100 : 0;

  return (
    <div className="flex items-center gap-2 bg-brand/5 border border-brand/20 rounded-lg px-3 py-2" data-testid="voice-player">
      <audio
        ref={audioRef}
        src={url}
        preload="metadata"
        onTimeUpdate={() => audioRef.current && setPlaybackTime(audioRef.current.currentTime)}
        onLoadedMetadata={() => audioRef.current && setAudioDuration(audioRef.current.duration)}
        onEnded={() => { setIsPlaying(false); setPlaybackTime(0); }}
      />
      <Mic className="w-4 h-4 text-brand flex-shrink-0" />
      <Button type="button" size="icon" variant="ghost" onClick={togglePlayback} className="w-8 h-8 flex-shrink-0" data-testid="voice-player-play-btn">
        {isPlaying ? <Pause className="w-4 h-4 text-brand" /> : <Play className="w-4 h-4 text-brand" />}
      </Button>
      <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
        <div className="h-full bg-brand rounded-full transition-all duration-200" style={{ width: `${progress}%` }} />
      </div>
      <span className="text-xs text-muted-foreground w-10 text-end flex-shrink-0">
        {formatTime(isPlaying ? playbackTime : audioDuration)}
      </span>
    </div>
  );
}
